import * as React from "react";

export const Profile = () => (
  <div>
    <p>Hi, *username*</p>
  </div>
);
